// Brand logos come from env URLs (like tm-admin-web-react), not bundled files.
// LOGO = full logo; FAV_LOGO = icon (tab icon, collapsed sidebar).
export const FAV_LOGO_URL = process.env.REACT_APP_FAV_LOGO || "/favicon.png";
export const LOGO_URL = process.env.REACT_APP_LOGO || FAV_LOGO_URL;

// The company printed at the top of an invoice (set them in the env file of the deployment).
export const COMPANY = {
  name: process.env.REACT_APP_COMPANY_NAME || "deshMART",
  address: process.env.REACT_APP_COMPANY_ADDRESS || "",
  phone: process.env.REACT_APP_COMPANY_PHONE || "",
  email: process.env.REACT_APP_COMPANY_EMAIL || "",
};

export const API_URL =process.env.REACT_APP_API_URL || "";

// When true, services return local mock data instead of calling the API
// (set REACT_APP_USE_MOCK in .env.local while the backend isn't ready).
export const USE_MOCK = process.env.REACT_APP_USE_MOCK === "true";
